import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { AlertCircle, ArrowLeft } from 'lucide-react';

export default function ForgotPassword() {
  return (
    <div className="min-h-screen bg-[#1A1D23] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Card className="bg-[#23272F] border-[#2D3139]">
          <CardHeader className="text-center pb-2">
            <div className="mx-auto w-12 h-12 bg-[#1ABC9C]/10 rounded-full flex items-center justify-center mb-4">
              <AlertCircle className="w-6 h-6 text-[#1ABC9C]" />
            </div>
            <CardTitle className="text-xl text-white">Password Reset</CardTitle>
          </CardHeader>
          <CardContent className="pt-4">
            <div className="text-center space-y-4">
              <p className="text-[#C7C7C7]">
                Password reset is currently handled manually.
              </p>
              <p className="text-[#C7C7C7]">
                Please contact the admin to regain access.
              </p>
              
              <div className="pt-4">
                <Link to="/login">
                  <Button 
                    variant="outline" 
                    className="w-full border-[#2D3139] text-[#C7C7C7] hover:bg-[#2D3139] hover:text-white"
                    data-testid="back-to-login-btn"
                  >
                    <ArrowLeft className="w-4 h-4 mr-2" />
                    Back to Login
                  </Button>
                </Link>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
